import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getAlbumById, getRelatedAlbums } from '../data/albums';
import { getTitlesByAlbumId } from '../data/albumsTitles';
import HorizontalScrollMediaView from '../components/HorizontalScrollMediaView';
import AlbumHeader from '../components/AlbumHeader';
import AlbumTable from '../components/AlbumTable';
import { ArrowLeft, Home } from 'lucide-react';
import Footer from '../components/Footer';

const Album = () => {

  document.title = "Album";

  const { albumId } = useParams();
  const navigate = useNavigate();
  const album = getAlbumById(Number(albumId));
  const titles = getTitlesByAlbumId(Number(albumId));
  const relatedAlbums = getRelatedAlbums(Number(albumId));

  useEffect(() => {
    if (album === null) {
      navigate('/404');
    }
  }, [album, navigate]);

  if (album === null) {
    return null;
  }

  const { title, artist, cover_art, duration, totalTracks, releaseDate } = album;
  const releaseYear = releaseDate.split("-").pop();

  return (
    <div className="mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20 min-h-screen">
      <div className="absolute top-5 left-3 flex gap-2">
        <button
          onClick={() => navigate(-1)}
          className="p-2 bg-charcoal rounded-full hover:bg-hover-charcoal transition duration-300"
        >
          <ArrowLeft className="text-white w-5 h-5" />
        </button>

        <Link
          to="/"
          className="p-2 bg-charcoal rounded-full hover:bg-hover-charcoal transition duration-300"
        >
          <Home className="text-white w-5 h-5" />
        </Link>
      </div>
      <AlbumHeader
        title={title}
        artist={artist}
        coverImage={cover_art}
        releaseYear={releaseYear}
        totalTracks={totalTracks}
        duration={duration}
      />
      <AlbumTable titles={titles} />
      <div className="py-4">
        <p className="text-sm text-gray-400 pl-1">{releaseYear}</p>
        <p className="text-sm text-gray-400 pl-1">{artist}</p>
      </div>
      {relatedAlbums.length > 0 && 
        <HorizontalScrollMediaView 
          collection={relatedAlbums} 
          headTitle={`More Albums by ${artist}`} 
          route="album" 
        />
      }
      <Footer />
    </div>
  );
};

export default Album;